exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tblCool td{padding:0!important}.table .t_blue{background-color:#387ab5!important;color:#fff}", ""]);

// exports
